require.register("documenteditor/helpers/menuGroup", function(exports, require, module){
  $0
  
});

